module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/ivy-morton-a065548b36254bccb11312cdf7df24cd.jpg";